(function() {
    'use strict';

    var InvioCredenzialiSezioneCtrl = function(
        $q,
        $scope,
        $state,
        $stateParams,
        $cacheFactory,
        CONSTANTS,
        messaggiFctr,
        invioCredenzialiSezioneService,
        invioCredenzialiService,
        gestioneUtenteService
    ) {

        this.loading = 0;
        this.tipoCredenziale = '';
        this.tipoDiInvioSelezionato = '';
        this.recapito = '';
        this.credenzialeInviata = false;
        this.invioCredenzialiService = invioCredenzialiService;

        this.init = () => {
            this.tipoCredenziale = this.credenziale;
            this.tipoDiInvioSelezionato = this.tipoCredenziale === 'codice' ? 'EMAIL' : 'SMS';
            this.verificaCodiceAttivazioneDigitale = null;

            this.datiMito = this.invioCredenzialiService.datiMito;
            if (this.datiMito && this.datiMito.idOrganizzazione) {
                this.caricaLimiti();
                this.checkCad();
            } else {
                this.ricaricaUtenzaMito($stateParams.codiceUtente);
            }            
        };

        this.ricaricaUtenzaMito = (codiceUtente) => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            gestioneUtenteService.getDatiMito(codiceUtente)
                .then(
                    (resp) => {
                        if (messaggiFctr.processaResponse(resp)) {
                            return;
                        }

                        let dtoOutput = resp.data.result;
                        this.datiMito = invioCredenzialiService.datiMito = dtoOutput.utenzaMito;
                        this.caricaLimiti();
                        this.checkCad();
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(
                    () => {
                        this.loading--;
                    }
                );
        };

        this.valutaStatoUtente = () => {
            this.statoUtente = "DISATTIVO";
            if (this.datiMito && (this.datiMito.erroriPassword < this.massimoErroriPassword)) {
                this.statoUtente = "ATTIVO";
            }

            this.statoAttivazione = "DISATTIVO";
            if (this.datiMito && (!this.massimoErroriCodiceSicurezza || (this.datiMito.erroriCodiceSicurezza < this.massimoErroriCodiceSicurezza))) {
                this.statoAttivazione = "ATTIVO";
            }
            
            this.erroriStatoPassword = this.datiMito.erroriPassword + '/' + this.massimoErroriPassword;
            this.erroriAttivazione = this.datiMito.erroriCodiceSicurezza + '/' + this.massimoErroriCodiceSicurezza;;
        };

        this.setCanale = () => {
            if (this.tipoDiInvioSelezionato === 'SMS' && !!invioCredenzialiService.datiMito.elencoContatti && invioCredenzialiService.datiMito.elencoContatti.length > 0) {
                const principale = invioCredenzialiService.datiMito.elencoContatti.find(contatto => contatto.principale === 1);
                if (!!principale) {
                    this.recapito = principale.numero;
                    return true;
                };
            };
            if (this.tipoDiInvioSelezionato === 'EMAIL' && !!invioCredenzialiService.datiMito.email) {
                this.recapito = invioCredenzialiService.datiMito.email;
                return true;
            };
            this.mostraMessaggioNessunRecapito();
            return false;
        };

        this.mostraMessaggioNessunRecapito = () => {
            const message = {
                message: 'Non è stato rilevato un recapito valido, non sarà possibile effettuare l\'invio delle credenziali. Si prega di selezionare un canale diverso oppure verificare la posizione anagrafica.',
                type: 'W'
            };
            messaggiFctr.addMessage(message);
        };

        this.mostraMessaggioErrore = () => {
            const message = {
                message: 'Non è possibile inviare le credenziali tramite il medesimo canale',
                type: 'W'
            };
            messaggiFctr.addMessage(message);
        };

        this.mostraMessaggioNessunRecapito = () => {
            const message = {
                message: 'Il numero selezionato non è valido, non sarà possibile effettuare l\'invio delle credenziali. Si prega di selezionare un canale diverso oppure verificarne il valore dalla posizione anagrafica (possibili caratteri illegali nel numero).',
                type: 'W'
            };
            messaggiFctr.addMessage(message);
        };

        this.mostraMessaggioInvioAvvenuto = () => {
            let cred = '';
            switch (this.tipoCredenziale) {
                case 'codice':
                    cred = "del Codice Utente";
                    break;            
                case 'password':
                    cred = "della Password";
                    break;            
                case 'attivazione':
                    cred = "del Codice di Attivazione";
                    break;    
            }
            const message = {
                message: 'Invio ' + cred + ' avvenuto con successo tramite il canale indicato',
                type: 'I'
            };
            messaggiFctr.addMessage(message);
        };

        this.controllaCanaleLibero = () => {            
            if (this.tipoCredenziale === 'codice') {                
                invioCredenzialiService.canaliInvioCredenziali.codice = this.tipoDiInvioSelezionato;
                if (invioCredenzialiService.canaliInvioCredenziali.password === this.tipoDiInvioSelezionato) {
                    this.mostraMessaggioErrore();
                    return false;
                } else return true;
            } else {
                invioCredenzialiService.canaliInvioCredenziali.password = this.tipoDiInvioSelezionato;
                if (invioCredenzialiService.canaliInvioCredenziali.codice === this.tipoDiInvioSelezionato) {
                    this.mostraMessaggioErrore();
                    return false;
                } else return true;
            };
        };

        this.canaleInvioEmail = () => {
            return this.tipoDiInvioSelezionato === 'EMAIL';
        };

        this.canaleInvioSms = () => {
            return this.tipoDiInvioSelezionato === 'SMS';
        };

        this.inviaCredenziali = () => {
            if (!this.controllaCanaleLibero() || (!this.recapito && !this.setCanale())) return;
            let contattoFinale = this.recapito.trim();
            if (this.tipoDiInvioSelezionato === 'SMS') {
                contattoFinale = invioCredenzialiService.datiMito.elencoContatti.find(contatto => 
                    contattoFinale.startsWith('+') 
                    ? contattoFinale == ('+' + contatto.prefisso.trim() + contatto.numero.trim()) 
                    : contattoFinale == contatto.numero.trim()
                );
            };
            if (!contattoFinale) {
                this.mostraMessaggioNessunRecapito();
                return;
            }
            
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            invioCredenzialiSezioneService
                .inviaCredenziale(this.tipoCredenziale, this.invioCredenzialiService.datiMito.codiceUtente, 
                                  this.tipoDiInvioSelezionato, contattoFinale)
                    .then(
                        (resp) => {
                            if (messaggiFctr.processaResponse(resp)) {
                                return;
                            };
                            this.credenzialeInviata = true;
                            this.mostraMessaggioInvioAvvenuto();
                        },
                        (error) => {
                            messaggiFctr.processaResponse(error);
                        }
                    )
                    .finally(() => {
                        this.loading--;
                    });
        };

        this.inviaCodiceAttivazione = () => {
            let codiceUtente = this.invioCredenzialiService.datiMito.codiceUtente;

            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            invioCredenzialiSezioneService
                .inviaCodiceAttivazioneDigitale(codiceUtente)
                    .then(
                        (resp) => {
                            if (messaggiFctr.processaResponse(resp)) {
                                return;
                            };
                            this.credenzialeInviata = true;
                            this.mostraMessaggioInvioAvvenuto();
                        },
                        (error) => {
                            messaggiFctr.processaResponse(error);
                        }
                    )
                    .finally(() => {
                        this.loading--;
                    });
        };

        this.caricaLimiti = () => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            invioCredenzialiSezioneService
                .leggiLimiti(this.datiMito.idOrganizzazione)
                    .then(
                        (resp) => {
                            if (messaggiFctr.processaResponse(resp)) {
                                return;
                            };
                            this.massimoErroriCodiceSicurezza = resp.data.result.massimoErroriCodiceSicurezza;
                            this.massimoErroriPassword = resp.data.result.massimoErroriPassword;

                            this.valutaStatoUtente();
                        },
                        (error) => {
                            messaggiFctr.processaResponse(error);
                        }
                    )
                    .finally(() => {
                        this.loading--;
                    });
        };

        this.checkCad = () => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;
            invioCredenzialiSezioneService
                .verificaCodiceAttivazioneDigitale(this.datiMito.codiceUtente)
                    .then(
                        (resp) => {
                            if (messaggiFctr.processaResponse(resp)) {
                                return;
                            };
                            this.verificaCodiceAttivazioneDigitale = resp.data.result;
                        },
                        (error) => {
                            messaggiFctr.processaResponse(error);
                        }
                    )
                    .finally(() => {
                        this.loading--;
                    });
        };

        $scope.$on('datiMitoChange', function (event, args) {
            event.currentScope.invioCredenzialiSezioneCtrl.setCanale();
        });

        this.init();
    };

    InvioCredenzialiSezioneCtrl.$inject = [
        '$q',
        '$scope',
        '$state',
        '$stateParams',
        '$cacheFactory',
        'Mitom_CONSTANTS',
        'MitomMessaggiFctr',
        'MitomInvioCredenzialiSezioneService',
        'MitomInvioCredenzialiService',
        'MitomGestioneUtenteService'
    ];

    var TemplateUrl = function(CONSTANTS) {
        return (
            CONSTANTS.BASE_ROOT +
            CONSTANTS.COMPONENTS_PATH +
            'mitoman-invio-credenziali/mitoman-invio-credenziali-sezione/invioCredenzialiSezione.component.html'
        );
    };
    TemplateUrl.$inject = ['Mitom_CONSTANTS'];

    var InvioCredenzialiSezioneComponent = {
        bindings: { credenziale: '<' },
        controller: InvioCredenzialiSezioneCtrl,
        controllerAs: 'invioCredenzialiSezioneCtrl',
        templateUrl: TemplateUrl
    };

    angular
        .module('cbl.mitomanager.wa')
        .component(
            'mitominvioCredenzialiSezione',
            InvioCredenzialiSezioneComponent
        );
})();